<!-- 富文本编辑 -->
<template>
  <div class="editor-wrapper">
    <div style="z-index:100; position: relative"
         :id="editorId">
    </div>
  </div>
</template>

<script>
import Editor from 'wangeditor'
import 'wangeditor/release/wangEditor.min.css'
import { editorImgUpload } from '@/api/upload'

export default {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: ''
    },
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: 'html',
      validator: (val) => {
        return ['html', 'text'].includes(val)
      }
    },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },
    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editorId () {
      return `editor${this._uid}`
    }
  },
  methods: {
    setHtml (val) {
      this.editor.txt.html(val)
    }
  },
  mounted () {
    let self = this
    this.editor = new Editor(`#${this.editorId}`)
    this.editor.customConfig.lang = {
      '设置标题': 'Tittle',
      '正文': 'Text',
      '字号': 'Size',
      '字体': 'Font',
      '宋体': 'Song Typeface',
      '微软雅黑': 'Microsoft YaHei',
      '文字颜色': 'Font Color',
      '链接': 'Link',
      '链接文字': 'Link Text',
      'Link文字': 'Link',
      '图片Link': 'Link',
      '插入表格': 'Insert Table',
      '插入': 'Insert',
      '上传图片': 'Upload IMG',
      '网络图片': 'IMG URL',
      '图片链接': 'URL',
      '创建': 'Create',
      '设置列表': 'List',
      '有序列表': 'Ordered (list column)',
      '无序列表': 'Unordered (list column)',
      '对齐方式': 'Align',
      '靠左': 'Left',
      '靠中': 'Center',
      '靠右': 'Right',
      '行': 'row(s)',
      '列': 'column(s)',
      '的表格': '\'s table'
      // 还可自定添加更多
    }
    this.editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'foreColor', // 文字颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'image', // 插入图片
      'table', // 表格
      'undo', // 撤销
      'redo' // 重复
    ]
    this.editor.customConfig.onchange = (html) => {
      let text = this.editor.txt.text()
      if (this.cache) localStorage.editorCache = html
      this.$emit('input', this.valueType === 'html' ? html : text)
      this.$emit('on-change', html, text)
    }
    this.editor.customConfig.onchangeTimeout = this.changeInterval
    // 上传，目前仅单文件上传，如果需要多文件，可以提供对应后台的api
    this.editor.customConfig.uploadImgMaxLength = 1
    this.editor.customConfig.customUploadImg = function (files, insert) {
      files = files[0]
      // 判断格式
      let type = files.name.substring(files.name.lastIndexOf('.') + 1)
      console.log(type)
      if (!['jpg', 'png', 'jpeg'].includes(type)) {
        let msg = 'Please note: Only “.jpg / .png / .jpeg” files can be uploaded. '
        self.$zlr_message(msg, 'error')
        return false
      }
      editorImgUpload({ file: files[0] }).then(res => {
        let sourceLink = `https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/${res.name}`
        self.editor.cmd.do('insertHtml', '<img src="' + sourceLink + '" style="max-width:100%;"/>')
      })
    }
    this.editor.customConfig.customAlert = function (info) {
      self.$zlr_message(info, 'error')
    }
    // create这个方法一定要在所有配置项之后调用
    this.editor.create()
    // 如果本地有存储加载本地存储内容
    let html = this.value || localStorage.editorCache
    if (html) this.editor.txt.html(html)
  }
}
</script>

<style>
</style>
